// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroTile_wrapper__xfcff","image":"HeroTile_image__6g1Zf","title":"HeroTile_title__8rBY1"};